import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6faed494"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "15px 0 10px 0",
    "display": "flex"
  }
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "相机", -1);
});

var _hoisted_3 = {
  class: "ver",
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_4 = {
  class: "grid-content ep-bg-purple"
};
var _hoisted_5 = {
  class: "grid-content ep-bg-purple-light"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "25px 0 10px 0"
    }
  }, [/*#__PURE__*/_createElementVNode("h4", null, "测试设备验证列表")], -1);
});

var _hoisted_7 = {
  class: "grid-content ep-bg-purple"
};
var _hoisted_8 = {
  class: "dis-sp"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "请输入设备ID", -1);
});

var _hoisted_10 = {
  class: "div-body"
};
var _hoisted_11 = {
  class: "dialog-footer"
};
var _hoisted_12 = {
  class: "div-body",
  style: {
    "min-height": "500px"
  }
};
var _hoisted_13 = {
  class: "dialog-footer"
};
import { onMounted, ref } from "@vue/runtime-core";
import { Search } from "@element-plus/icons-vue";
import { getComTesDevice, getTesDeviceList, addTesDeviceList, deleteTesDeviceList, validTsVersion, addComTesDevice, deleteComTesDevice } from "@/api/xmManagement/file/file";
import router from "../../router";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  __name: 'testEquipment',
  setup: function setup(__props) {
    var productInfo = ref({
      productName: undefined,
      version: undefined,
      product: undefined,
      ota_type: undefined
    });
    var dialogVaild = ref(false);
    var addVaildSNList = ref();
    var addValidDeviceDig = ref(false);
    var validListTitle = ref("请选择测试白名单管理中的设备");
    var validList = ref({
      list: []
    }); // 常用测试设备列表
    // 测试设备列表

    var testList = ref({
      list: []
    }); // 删除条件

    var deleteForm = ref({
      product: undefined,
      list: []
    });
    var queryValidList = ref({
      sn: undefined
    }); // 打开测试白名单对话框

    var openDigVaild = function openDigVaild() {
      dialogVaild.value = true;
      getComTesDeviceList();
    }; // 打开设备号之间添加


    var addSnList = function addSnList() {
      addValidDeviceDig.value = true;
    }; // 添加常用测试设备


    var addComTsDevice = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, snList, query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                list = addVaildSNList.value.split(",");
                snList = list.map(function (item) {
                  var sn = {
                    sn: item
                  };
                  return sn;
                });
                query = {
                  product: productInfo.value.product,
                  list: snList
                };
                _context.next = 5;
                return addComTesDevice(query).then(function (res) {
                  ElMessage.success("添加成功");
                  addVaildSNList.value = null;
                }).catch(function () {
                  ElMessage.error("添加失败");
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function addComTsDevice() {
        return _ref.apply(this, arguments);
      };
    }(); // 常用设备表格多选


    var handleSelectionChange = function handleSelectionChange(row) {
      console.log(row);

      if (row.length > 0) {
        deleteForm.value.list = row.map(function (item) {
          var items = {
            sn: item.sn
          };
          return items;
        });
      } else {
        deleteForm.value.list = [];
      }
    };

    var selectList = []; // 测试设备表格多选

    var testDeviceChange = function testDeviceChange(row) {
      selectList = row.map(function (item) {
        return {
          sn: item.sn
        };
      });
    };

    var deleteTsDeviceEvent = function deleteTsDeviceEvent(row) {
      var list = [];

      if (row === 1) {
        list = selectList;
      } else {
        list = [{
          sn: undefined
        }];
        list[0].sn = row.sn;
      }

      var deleteForms = {
        product: productInfo.value.product,
        ota_type: productInfo.value.ota_type,
        version: productInfo.value.version,
        list: list
      };
      ElMessageBox.confirm("确认删除该常用设备?", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteTesDeviceList(deleteForms).then(function () {
                  ElMessage.success("删除成功");
                  getTesDeviceLists();
                }).catch(function () {
                  ElMessage.error("删除失败");
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }; // 批量删除常用设备


    var deleteComTesDeviceList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(deleteForm.value.list.length === 0)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                deleteForm.value.product = productInfo.value.product;
                ElMessageBox.confirm("确认删除该常用设备?", {
                  confirmButtonText: "确认",
                  cancelButtonText: "取消"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return deleteComTesDevice(deleteForm.value).then(function () {
                            ElMessage.success("删除成功");
                            getComTesDeviceList();
                          }).catch(function () {
                            ElMessage.error("删除失败");
                          });

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function deleteComTesDeviceList() {
        return _ref3.apply(this, arguments);
      };
    }(); // 验证


    var validUpload = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var validForm;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                validForm = {
                  product: productInfo.value.product,
                  ota_type: productInfo.value.ota_type,
                  version: productInfo.value.version
                };
                _context5.next = 3;
                return validTsVersion(validForm).then(function (res) {}).catch(function () {});

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function validUpload() {
        return _ref5.apply(this, arguments);
      };
    }(); // 获取常用测试设备


    var getComTesDeviceList = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var products;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                products = {
                  product: productInfo.value.product
                };
                _context6.next = 3;
                return getComTesDevice(products).then(function (res) {
                  validList.value = res;
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function getComTesDeviceList() {
        return _ref6.apply(this, arguments);
      };
    }(); // 获取测试设备列表


    var getTesDeviceLists = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(item) {
        var query, _query;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!item) {
                  _context7.next = 6;
                  break;
                }

                query = {
                  product: item.product,
                  ota_type: item.ota_type,
                  version: item.version
                };
                _context7.next = 4;
                return getTesDeviceList(query).then(function (res) {
                  testList.value = res;
                });

              case 4:
                _context7.next = 9;
                break;

              case 6:
                _query = {
                  product: productInfo.value.product,
                  ota_type: productInfo.value.ota_type,
                  version: productInfo.value.version
                };
                _context7.next = 9;
                return getTesDeviceList(_query).then(function (res) {
                  testList.value = res;
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function getTesDeviceLists(_x) {
        return _ref7.apply(this, arguments);
      };
    }(); // 批量添加测试设备


    var addTesDevices = function addTesDevices() {
      var list = addVaildSNList.value.split(",");
      var snList = list.map(function (item) {
        var sn = {
          sn: item
        };
        return sn;
      });
      saveTesDevice(snList);
    };

    var saveTesDevices = function saveTesDevices() {
      saveTesDevice(deleteForm.value.list);
    }; // 批量添加


    var saveTesDevice = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(snList) {
        var query;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                query = {
                  product: productInfo.value.product,
                  version: productInfo.value.version,
                  ota_type: productInfo.value.ota_type,
                  list: snList
                };
                _context8.next = 3;
                return addTesDeviceList(query).then(function (res) {
                  ElMessage.success("添加成功");
                  addVaildSNList.value = null;
                  getTesDeviceLists();

                  if (dialogVaild.value) {
                    dialogVaild.value = false;
                  }
                }).catch(function () {
                  ElMessage.error("添加失败");
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function saveTesDevice(_x2) {
        return _ref8.apply(this, arguments);
      };
    }(); //


    onMounted(function () {
      productInfo.value = router.currentRoute.value.query;
      getTesDeviceLists(productInfo.value);
    });
    return function (_ctx, _cache) {
      var _component_el_tag = _resolveComponent("el-tag");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_button_group = _resolveComponent("el-button-group");

      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      var _component_el_card = _resolveComponent("el-card");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_card, {
        class: "box-card",
        style: {
          "position": "relative"
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tag, {
            class: "mx-1",
            effect: "plain",
            round: "",
            type: "success"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("固件版本: " + _toDisplayString(_unref(productInfo).version), 1)];
            }),
            _: 1
          })])]), _createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_4, " 固件类型: " + _toDisplayString(_unref(productInfo).ota_type), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_5, " 所属产品: " + _toDisplayString(_unref(productInfo).productName), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _hoisted_6, _createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_7, [_createTextVNode(" 测试结果仅代表OTA升级是否成功，即设备当前固件版本与目标版本一致，不包含固件功能可用性测试。"), _createVNode(_component_el_button, {
                    type: "text"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("请参考文档")];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button_group, {
            style: {
              "margin": "15px 0 0 0"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                style: {
                  "margin-right": "10px"
                },
                onClick: openDigVaild
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("从常用验证设备中选择添加")];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                onClick: addSnList
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("通过设备号直接添加")];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "error",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return deleteTsDeviceEvent(1);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("删除")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: validUpload
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("验证是否完成升级")];
            }),
            _: 1
          })]), _createVNode(_component_el_table, {
            stripe: "",
            "row-style": {
              height: '40px'
            },
            style: {
              "width": "100%",
              "border-radius": "5px",
              "margin-top": "20px"
            },
            ref: "refTable",
            id: "scroll",
            data: _unref(testList).list,
            "header-cell-style": {
              color: '#333333'
            },
            onSelectionChange: testDeviceChange
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }), _createVNode(_component_el_table_column, {
                align: "center",
                prop: "ota_type",
                label: "产品类型"
              }), _createVNode(_component_el_table_column, {
                align: "center",
                prop: "version",
                label: "版本"
              }), _createVNode(_component_el_table_column, {
                align: "center",
                prop: "sn",
                label: "序列号"
              }), _createVNode(_component_el_table_column, {
                align: "center",
                prop: "status",
                label: "测试结果"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("span", null, _toDisplayString(scope.row.status === 0 ? "验证失败" : "验证成功"), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                align: "center",
                label: "操作"
              }, {
                default: _withCtx(function (scope) {
                  return [_createVNode(_component_el_button, {
                    type: "text",
                    onClick: function onClick($event) {
                      return deleteTsDeviceEvent(scope.row);
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("删除")];
                    }),
                    _: 2
                  }, 1032, ["onClick"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data"])];
        }),
        _: 1
      }), _createVNode(_component_el_dialog, {
        width: "550px",
        modelValue: _unref(addValidDeviceDig),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(addValidDeviceDig) ? addValidDeviceDig.value = $event : null;
        }),
        "append-to-body": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_11, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: addComTsDevice
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("保存到常用测试设备")];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return addValidDeviceDig.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("取消")];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: addTesDevices
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("确定")];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
            type: "textarea",
            size: "auto",
            modelValue: _unref(addVaildSNList),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(addVaildSNList) ? addVaildSNList.value = $event : null;
            }),
            placeholder: "搜索当前pid下的设备ID, 批量数据请用“,”隔开"
          }, null, 8, ["modelValue"])])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        width: "550px",
        modelValue: _unref(dialogVaild),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return _isRef(dialogVaild) ? dialogVaild.value = $event : null;
        }),
        title: _unref(validListTitle),
        "before-close": _ctx.handleClose,
        "append-to-body": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_13, [_createVNode(_component_el_button, {
            type: "warning",
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return deleteComTesDeviceList();
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("删除")];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: saveTesDevices
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("添加")];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return dialogVaild.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("关闭")];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input, {
            modelValue: _unref(queryValidList).sn,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return _unref(queryValidList).sn = $event;
            }),
            placeholder: "设备ID"
          }, {
            append: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                icon: _unref(Search)
              }, null, 8, ["icon"])];
            }),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_table, {
            "max-height": "100%",
            style: {
              "width": "100%",
              "margin-top": "20px"
            },
            stripe: "",
            "header-cell-style": {
              color: '#333333',
              background: '#F2F3F5'
            },
            data: _unref(validList).list,
            onSelectionChange: handleSelectionChange
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }), _createVNode(_component_el_table_column, {
                label: "设备ID",
                align: "center",
                prop: "sn"
              }), _createVNode(_component_el_table_column, {
                label: "用户ID",
                align: "center",
                prop: "userId"
              })];
            }),
            _: 1
          }, 8, ["data"])])];
        }),
        _: 1
      }, 8, ["modelValue", "title", "before-close"])]);
    };
  }
};